import { render, staticRenderFns } from "./DetailGroup.vue?vue&type=template&id=590d5985&scoped=true&"
import script from "./DetailGroup.vue?vue&type=script&lang=js&"
export * from "./DetailGroup.vue?vue&type=script&lang=js&"
import style0 from "./DetailGroup.vue?vue&type=style&index=0&id=590d5985&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d5985",
  null
  
)

export default component.exports